//src/hooks/useReports.ts
import { useMutation, useQuery } from "@tanstack/react-query";

import {
  downloadRiskInventoryExcelReport,
  getCampaignAnalyticsReport,
  getPsychosocialEvolutionReport,
  getReportsOptions,
  getRiskInventoryActionPlansReport,
  type CampaignAnalyticsFilters,
  type PsychosocialEvolutionFilters,
  type RiskInventoryActionPlansFilters,
} from "@/services/reports";

export function useReportsOptions() {
  return useQuery({
    queryKey: ["reports_options"],
    queryFn: getReportsOptions,
    staleTime: 60_000,
  });
}

export function useGeneratePsychosocialEvolutionReport() {
  return useMutation({
    mutationFn: (params: PsychosocialEvolutionFilters) => getPsychosocialEvolutionReport(params),
  });
}

export function useGenerateCampaignAnalyticsReport() {
  return useMutation({
    mutationFn: (params: CampaignAnalyticsFilters) => getCampaignAnalyticsReport(params),
  });
}

export function useGenerateRiskInventoryActionPlansReport() {
  return useMutation({
    mutationFn: (params: RiskInventoryActionPlansFilters) => getRiskInventoryActionPlansReport(params),
  });
}

export function useDownloadRiskInventoryExcelReport() {
  return useMutation({
    mutationFn: (params: RiskInventoryActionPlansFilters) => downloadRiskInventoryExcelReport(params),
  });
}
